document.addEventListener('DOMContentLoaded', () => {
	if (!document.querySelector('.experts')) {
		return;
	}
	const resetButton = document.querySelector('.reset-sort');
	let sortField = '';
	let facets = '';

	document.addEventListener('facetwp-loaded', () => {
		sortField = document.querySelector('.sort-wrapper select');
		facets = FWP.facets;
		console.log(facets);

		// Check if any facet array has selected items
		const hasSelection = Object.values(facets).some((facet) => facet.length > 0);

		if (hasSelection) {
			resetButton.classList.remove('hidden');
		}
	});
	const sortCurrentToggles = document.querySelectorAll('.sort-toggle');

	if (resetButton) {
		resetButton.addEventListener('click', (e) => {
			sortCurrentToggles.forEach((toggle) => {
				toggle.classList.remove('asc');
				toggle.classList.remove('desc');
			});

			FWP.reset();
		});
	}

	sortCurrentToggles.forEach((currentToggle) => {
		const sort_type = currentToggle.getAttribute('data-sort-type');
		let sort = '';
		currentToggle.addEventListener('click', (e) => {
			// Reset all other toggles
			sortCurrentToggles.forEach((toggle) => {
				if (toggle !== currentToggle) {
					toggle.classList.remove('asc');
					toggle.classList.remove('desc');
				}
			});

			// Toggle current toggle
			if (currentToggle.classList.contains('asc')) {
				currentToggle.classList.remove('asc');
				currentToggle.classList.add('desc');
				sort = sort_type + '_desc';
			} else {
				currentToggle.classList.remove('desc');
				currentToggle.classList.add('asc');
				sort = sort_type + '_asc';
			}

			// Update the select
			sortField.value = sort;
			const event = new Event('change', { bubbles: true });
			sortField.dispatchEvent(event);
			FWP.refresh();
		});
	});
});
